import React from "react";
import mergeLeft from "ramda/src/mergeLeft";
import EditorSearchIcon from "@atlaskit/icon/glyph/editor/search";
import EditorCloseIcon from "@atlaskit/icon/glyph/editor/close";

import { useDebounce } from "../../hooks/useDebounce";
import { Grid } from "../../UI/Grid";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { TextField } from "../TextField";
import { COLOR_FIORD } from "../../constants/styles";
import { FiltersDropdown } from "./FiltersDropdown";

interface IProps {
  filterState: any;
  setFilter: any;
  l2Information: any;
  isUsersVisible: any;
}

const SearchElemAfterInput = (
  <Box mr={1} display="flex" alignItems="center">
    <EditorSearchIcon label="Search" primaryColor={COLOR_FIORD} />
  </Box>
);

export const UsersMatchFilterOptions: React.FC<IProps> = (props) => {
  const [searchValue, setSearchValue] = React.useState("");
  const debouncedValue = useDebounce(searchValue, 500);

  React.useEffect(() => {
    if (!debouncedValue) return;

    props.setFilter(mergeLeft({ name: debouncedValue }));
  }, [debouncedValue, props.setFilter]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleFilterClose = (key: string) => () => {
    props.setFilter(mergeLeft({ [key]: "none" }));
    setSearchValue("");
  };

  const getFilterLabel = (key: string) => {
    return props.filterState[key];
  };

  return (
    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
      <Grid item width={280}>
        <TextField
          type="text"
          id="fist-name"
          value={searchValue}
          onChange={handleSearchChange}
          elemAfterInput={SearchElemAfterInput}
          placeholder="Search by first or last name"
        />
      </Grid>
      <Grid item>
        <Grid container spacing={1}>
          {Object.keys(props.filterState).map(
            (key) =>
              !!props.filterState[key] &&
              props.filterState[key] !== "none" &&
              props.filterState[key] !== "All" && (
                <Grid item key={key}>
                  <Button onClick={handleFilterClose(key)} iconAfter={<EditorCloseIcon label="Close" />}>
                    {getFilterLabel(key)} Only
                  </Button>
                </Grid>
              )
          )}
        </Grid>
      </Grid>
      <Grid item>
        <FiltersDropdown
          setFilter={props.setFilter}
          l2Information={props.l2Information}
          filterState={props.filterState}
        />
      </Grid>
    </Grid>
  );
};
